import React from 'react'
import "./style.css"
const Status = ({ status }) => {
  return (
    <div className={`status-container status-${status?.id}`}>{status?.name}</div>
  )
}

export default Status